import {
  POST_WAREHOUSE_STOCK_IMPORT,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/warehouse/stock/import/post'

import { api } from 'app/api'
import { WarehouseStockImportParams } from 'app/common/types/warehouse/stock'

export function useWarehouseStockImportFile({
  onUploadProgress,
}: {
  onUploadProgress?: (progressEvent: ProgressEvent) => void
} = {}) {
  const upload = async (params: WarehouseStockImportParams) => {
    const res = await api.request(POST_WAREHOUSE_STOCK_IMPORT, {
      error: 'Не удалось загрузить данные',
      params,
      additionalAxiosOptions: {
        onUploadProgress,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })
    return res
  }

  return {
    upload,
  }
}
